import { injectable, injectFromBase } from 'inversify'
import { RepoSettings } from '@/decorators/repositoryDecorators'
import type { Endpoint } from '@/services/endpoints'
import OrmApiRepository from '@/data/repositories/ormApiRepository'
import SenderIdPrice from '@/data/models/domain/senderId/SenderIdPrice'

@RepoSettings<Endpoint>({
  model: SenderIdPrice,
})
@injectable()
@injectFromBase()
export default class SenderIdPriceRepository extends OrmApiRepository<SenderIdPrice> {
  protected id = '1'

  public getPriceDetails() {
    return this.findEntityByIdOrNull(this.id)
  }

  public async fillPriceDetails() {
    const response = await this.getApiSource().get<SenderIdPrice>(this.endpointsService.getPath('senderIdPrice'))
    await this.insertOrUpdate([{ ...response.data, id: this.id }])
    return response.data
  }
}
